import { useMemo } from 'react';
import { GachaDetail } from '../types/resources/gachaDetail';
import { useI18nLn } from './store';

export const useGachaStatus = (props: GachaDetail) => {
  const today = Date.now();
  const start_at = new Date(props.start_at);
  const end_at = new Date(props.end_at);
  const { t } = useI18nLn();

  const statusText = useMemo(() => {
    if (today < start_at.getTime()) {
      return t('pages.gacha.unplayable.comingsoon');
    } else if (today > end_at.getTime()) {
      return t('pages.gacha.unplayable.discontinued');
    } else {
      switch (props.status) {
        case 'soldout':
          return t('pages.gacha.unplayable.soldout');

        case 'closing':
          return t('pages.gacha.unplayable.closing');

        default:
          return null;
      }
    }
  }, [props.status, start_at, end_at, today]);

  return { statusText };
};
